var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"annotations-skeleton"},[_c('div',{staticClass:"label-set-name-skeleton"},[_c('b-skeleton',{attrs:{"width":"20%","height":"8px"}})],1),_vm._l((_vm.numberOfLabelRows),function(n){return _c('div',{key:n},[_c('LoadingLabels')],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }